// Module
var code = "<template>\n    <require from=\"./../service/service-list\"></require>\n    <service-list if.bind=\"params.Id\" params.bind=\"params\" context=\"customer-services\" no-paging=\"true\" customerid.bind=\"params.Id\"></service-list>\n</template> ";
// Exports
export default code;